import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mt-8 mb-4" }
const _hoisted_3 = { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-play-light-gray" }, null, -1)

import TitleHeader from "@/components/TitleHeader.vue";
import AlertCard from "@/components/AlertCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountSecurity',
  setup(__props) {

const redirect_uri = encodeURI(`${process.env.VUE_APP_BACKEND_URL}/v1/auth/authorize`);
const url =
  process.env.VUE_APP_NODE_ENV === "development"
    ? `https://playincludedstaging.b2clogin.com/playincludedstaging.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_ResetPassword&client_id=10fda799-1779-4fc7-b455-b02ca4fabfc6&nonce=defaultNonce&redirect_uri=${redirect_uri}&scope=openid&response_type=code`
    : `https://playincluded.b2clogin.com/playincluded.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_RD_PRODUCTION_PASSWORD&client_id=a6d6df00-aa22-41fb-b741-dffa4660fdef&nonce=defaultNonce&redirect_uri=${redirect_uri}&scope=openid&response_type=code`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AlertCard, { type: "warning" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("change-password-warning")), 1)
      ]),
      _: 1
    }),
    _createVNode(TitleHeader, {
      title: _ctx.$t('account-security'),
      class: "mt-2"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("change-password")), 1),
      _createElementVNode("a", {
        href: _unref(url),
        class: "block h-10 px-3 py-2 mt-4 text-base font-normal text-white transition ease-in border rounded bg-primary focus:outline-none focus:shadow-outline-purple duration-50 w-fit"
      }, _toDisplayString(_ctx.$t("change-password")), 9, _hoisted_4)
    ]),
    _hoisted_5
  ]))
}
}

})